import React from 'react'
import PropTypes from 'prop-types'
import { Button, makeStyles } from '@material-ui/core'

const widthDefault = 120
const heightDefault = 48

function ActionButton(props) {
  const { onClick, isSecondary, type, name, width, height, disabled = false, googleMapsStyle = false } = props

  const useStyles = makeStyles({
    button: {
      minWidth: `${width ? width : widthDefault}px`,
      height: `${height ? height : heightDefault}px`,
      cursor: 'pointer'
    },
    googleMapsButton: {
      backgroundColor: googleMapsStyle ? '#ffffff' : undefined,
      border: googleMapsStyle ? '1px solid #dadce0' : undefined,
      borderRadius: googleMapsStyle ? '24px' : undefined,
      color: googleMapsStyle ? '#5f6368' : undefined,
      fontSize: googleMapsStyle ? '14px' : undefined,
      fontWeight: googleMapsStyle ? 500 : undefined,
      padding: googleMapsStyle ? '12px 24px' : undefined,
      textTransform: googleMapsStyle ? 'none' : undefined,
      '&:hover': {
        backgroundColor: googleMapsStyle ? '#f8f9fa' : undefined,
        boxShadow: googleMapsStyle ? '0 1px 3px rgba(0,0,0,0.1)' : undefined
      }
    }
  })
  const classes = useStyles()

  const onClickAction = () => {
    onClick && onClick()
  }

  return (
    <>
      {googleMapsStyle ? (
        <Button
          disabled={disabled}
          className={`${classes.button} ${classes.googleMapsButton}`}
          onClick={onClickAction}
          type={type}
          variant='outlined'
        >
          {name}
        </Button>
      ) : isSecondary ? (
        <Button disabled={disabled} className={classes.button} onClick={onClickAction} type={type} variant='text' style={{ color: '#0000008A' }}>
          {name}
        </Button>
      ) : (
        <Button disabled={disabled} className={classes.button} onClick={onClickAction} type={type} color='primary' variant='contained'>
          {name}
        </Button>
      )}
    </>
  )
}

ActionButton.propTypes = {
  onClick: PropTypes.func,
  isSecondary: PropTypes.bool,
  type: PropTypes.string,
  name: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  disabled: PropTypes.bool,
  googleMapsStyle: PropTypes.bool
}

export default ActionButton
